export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14180.8fbf361b.jpg";